import React, { useState, useMemo } from 'react';
import { Optional, Box, Column, Row } from '@honda-canada/design-system-react';
import { formattedCampaignTypes } from '../../utils/constants';
import { getCampaignType } from '../../utils/formatterHelpers';
import NoticeCard from './NoticeCard';
import themeStyles from './styles/NoticeSection.styles';
import VideoModal from './VideoModal';
import VideoButton from './VideoButton';
import useFetchVideoThumbnail from '../../hooks/useFetchVideoThumbnail';
import { campaignPropTypes } from '../../utils/interface';
import getVideoUrlType from '../../utils/getVideoUrlType';
import useConfiguration from '../../hooks/useConfiguration';
import componentConfig from './componentConfig';

const VideoContainer = themeStyles.apply(Box, 'VideoContainer');

const NoticeWithVideo = ({ campaign }) => {
  const { videoPreviewBackgroundColor } = useConfiguration(componentConfig);
  const { type, status, videoLink } = campaign;
  const campaignType = getCampaignType(type, status);
  const withVideo =
    videoLink && campaignType !== formattedCampaignTypes.CR && campaignType !== formattedCampaignTypes.CU;

  const [showModal, setShowModal] = useState(false);
  const videoType = useMemo(() => getVideoUrlType(videoLink), [videoLink]);
  const thumbNail = useFetchVideoThumbnail({ videoURL: videoLink, videoType });

  return (
    <Column width={withVideo ? 1 : [1, 1, 1 / 2]}>
      <Row
        // override default styling to have equal height per row
        height={withVideo ? 'auto' : ['auto', 'auto', '100%']}
        alignContent={withVideo ? 'flex-start' : ['flex-start', 'flex-start', 'stretch']}
      >
        <NoticeCard {...campaign} width={withVideo ? [1, 1, 'calc(50% - 12px)'] : 1} />
        <Optional when={withVideo}>
          <VideoContainer
            data-testid="cy-video-container"
            thumbNailImage={thumbNail}
            videoPreviewBackgroundColor={videoPreviewBackgroundColor}
            width={[1, 1, 'calc(50% + 12px)']}
          >
            <VideoButton
              videoLink={videoLink}
              videoType={videoType}
              onClick={() => setShowModal(prevState => !prevState)}
            />
          </VideoContainer>
          <VideoModal
            isOpen={showModal}
            closeModal={() => setShowModal(false)}
            allowClose
            source={videoLink}
            videoType={videoType}
            ariaLabel="video modal"
            closeAriaLabel="close video modal"
            data-testid="dsr-video-modal"
          />
        </Optional>
      </Row>
    </Column>
  );
};

NoticeWithVideo.propTypes = {
  campaign: campaignPropTypes.isRequired,
};

export default NoticeWithVideo;
